import React from 'react';

export default function Socials() {
  return (
    <ul className="socials">
      <li><a className="socials__link twitter" href="https://twitter.com/clickclackatx" target="_blank" rel="noreferrer"><span className="sr-only">twitter</span></a></li>
      <li><a className="socials__link instagram" href="https://www.instagram.com/ballteamplaylists/" target="_blank" rel="noreferrer"><span className="sr-only">instagram</span></a></li>
    </ul>
  )
}